export const NONE = 0;
export const PUBLIC = 1;
export const ADMIN = 2;